import React from 'react'
import {NavLink} from 'react-router-dom'
import cls from 'classnames'

import classes from './NavigationMenu.module.scss'

export default function NavigationMenu(props) {
	const links = Object.values(props.pages)
	const pages = Object.keys(props.pages)

	return (
		<nav>
			<ul
				className='nav nav-tabs'
			>
				{links.map((link, i) => {
					const isBlinked = link.isBlinked && props.location.pathname !== link.to
					const label = link.count
						? `${link.label} (${link.count})`
						: link.label

					return (
						link.isHidden
						? null
						: <li
							key={i}
							className='nav-item'
						>
							<NavLink
								to={link.to}
								exact={link.exact}
								data-page={pages[i]}
								className={cls({
									'nav-link': true,
									[classes.NavigationMenu__link]: true,
									[classes.NavigationMenu__link_blink]: isBlinked
								})}
								onClick={event => props.setPage(event.currentTarget.dataset.page)}
							>
								{label}
							</NavLink>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}